import * as actionTypes from '../actions/actionTypes';

// REDUCERS
export const reducer = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return {
        ...state,
        loading: true, 
        isAuth: false
      };

    case actionTypes.AUTH_REFRESH_SUCCESS:
    case actionTypes.AUTH_SUCCESS:
      return {
        ...state,
        userId: action.uuid,
        name: action.name,
        roles: action?.roles,
        loading: false,
        isAuth: true,
        error: null,
        accessToken: action?.accessToken
      };

    case actionTypes.AUTH_REFRESH_FAIL:
    case actionTypes.AUTH_FAIL:
      return  {
        ...state,
        isAuth: false,
        userId: null,
        name: null,
        loading: false,
        error: action?.error,
        roles: []
      };

    default: 
      return state;
  }
}